import React from 'react';
import { CNavLink } from "./c/CHeader";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import DashboardIcon from '@material-ui/icons/Dashboard';
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import AssignmentIcon from '@material-ui/icons/Assignment';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import MenuBookIcon from '@material-ui/icons/MenuBook';

/**
 * Single menu component
 * @param props
 * @returns {*}
 * @constructor
 */
function SingleMenu(props) {
    const t = useTranslations();
    const { to, openDrawerStatus, screenWidth, handleDrawerClose, title, titleKey, icon, isExact } = props;
    return (
        <CNavLink to={to} isExact={isExact}>
            <Tooltip placement="right-end" title={openDrawerStatus ? '' : title} aria-label={title}>
                <ListItem button onClick={screenWidth && screenWidth <= 800 ? handleDrawerClose : () => null}>
                    <ListItemIcon>
                        {icon}
                    </ListItemIcon>
                    <ListItemText primary={t(titleKey)}/>
                </ListItem>
            </Tooltip>
        </CNavLink>
    );
}

/**
 * Top menu list for web app
 * @param props
 * @returns {*}
 * @constructor
 */
function TopMenuList(props) {
    const isMobile = props.screenWidth < 768;
    return (
        <React.Fragment>
            {
                !isMobile && <>
                    <SingleMenu to="/my-app/" title="Dashboard" titleKey="dashboard" isExact={true}
                                icon={<DashboardIcon/>} {...props} />
                    <SingleMenu to="/my-app/tests" title="All Test" titleKey="all_test" isExact={false}
                                icon={<LayersIcon/>} {...props} />
                    <SingleMenu to="/my-app/test-series" title="Test Series" titleKey="test_series" isExact={false}
                                icon={<AssignmentIcon/>} {...props} />
                    <SingleMenu to="/my-app/full-mock-tests" title="Full Mock Tests" titleKey="FULL_MOCK_TESTS"
                                isExact={false}
                                icon={<MenuBookIcon/>}
                                {...props} />
                    <SingleMenu to="/my-app/practice-tests" title="Practice Test" titleKey="practice_test"
                                isExact={false}
                                icon={<i className="fa fa-clock-o  m-r-18" aria-hidden="true"/>}
                                {...props} />
                    <SingleMenu to="/my-app/completed-tests" title="Completed Test" titleKey="COMPLETED_TEST"
                                isExact={false}
                                icon={<i className="fa fa-check-square-o  m-r-18" aria-hidden="true"/>}
                                {...props} />
                    <SingleMenu to="/my-app/practice" title="Practice Questions" titleKey="PRACTICE" isExact={false}
                                icon={<i className="fa fa-question-circle" aria-hidden="true"/>}
                                {...props} />
                    <SingleMenu to="/my-app/saved-questions" title="Saved Questions" titleKey="saved" isExact={false}
                                icon={<i className="fa fa-bookmark" aria-hidden="true"/>}
                                {...props} />

                    <SingleMenu to="/my-app/reports" title="Reports" titleKey="reports" isExact={false}
                                icon={<BarChartIcon/>}
                                {...props} />
                </>
            }
        </React.Fragment>
    );
}

export default TopMenuList;
